import React from 'react';
import { css } from 'emotion';
import { withRouter } from 'react-router-dom';
import { CustomButton } from '../components/CustomButton';
import { Container } from '../components/Container';
import { ButtonContainer } from '../components/ButtonContainer';

import finalPageCheck from '../../assets/finalPageCheck.svg';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const contentStyle = css`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const imgStyle = css`
  width: 128px;
  align-self: center;
  margin-top: 5rem;
`;

const titleStyle = css`
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  margin: 3rem 0 1.5rem 0;
`;

const centeredTextStyle = css`
  font-family: Lato, sans-serif;
  text-align: center;
  margin-bottom: 1rem;
  font-size: 1rem;
`;

const pageContainer = css`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-areas: 'aside main main';
  background-color: var(--white);
  height: 100%;
  flex: 1;
  max-height: calc(100vh - 80px);

  @media (min-width: 1201px) {
    max-height: calc(100vh - 81px);
    grid-template-areas: 'aside main info';
  }

  @media (max-width: 768px) {
    grid-template-areas: 'main';
    grid-template-columns: 100%;
    grid-template-rows: auto;
  }
`;

const SuccessPage = withRouter(
  (props) => {
    const policyNumberStyle = css`
      color: #ff7300;
      font-weight: bold;
    `;
    return (
      <div className="App">
        <div className={pageContainer}>
          {/* <ProgressBar /> */}
          <Container>
            <div className={contentStyle}>
              <img src={finalPageCheck} alt="success" className={imgStyle} />
              <h1 className={titleStyle}>
                Update successful

              </h1>

              <p className={centeredTextStyle}>
                Your marketing settings have been successfully applied.

              </p>
            </div>

          </Container>
        </div>
        <Footer />
      </div>
    );
  }
);

export default SuccessPage;
